export const KeysOfResourceLocationForLanguage = [
    'name',
    'address',
    'fees',
    'businessHours',
    'referralRequired',
];
